import { i18n } from '@/plugins/i18n';
import { sortBy, camelCase } from 'lodash-es';
import { ACADEMIC_YEARS, type AcademicYear } from '@teamworksdev/influencer/core';

const academicYears = sortBy(Object.keys(ACADEMIC_YEARS).map((key) => ({
	id: ACADEMIC_YEARS[key as keyof typeof ACADEMIC_YEARS],
	name: i18n.global.t(`academicYears.${camelCase(key)}`),
})), 'name');

const academicYearsObj = academicYears.reduce((obj, academicYear) => {
	obj[academicYear.id] = academicYear.name;
	return obj;
}, {} as { [key in AcademicYear]: string });

export {
	academicYears,
	academicYearsObj,
};
